/* PROJ-67 Besties — Auswahl-Listen fuer das Editor-Formular.
 * THEME-ONLY. Bewusst NICHT geteilt: der Server bekommt den gewaehlten Wert
 * ueber die Config und braucht die Liste nie.
 *
 * Titel und Sprueche sind eine GESCHLOSSENE Liste, der Kunde tippt hier
 * nichts. Nur die Namen sind frei. Neue Eintraege koennen deshalb ohne
 * Ruecksicht auf beliebige Kundeneingaben gewaehlt werden -- die Automatik in
 * besties-engine.js haelt jeden Titel im Rahmen, notfalls per Sperrung und
 * waagerechtem Ziehen. Wer einen Titel von Hand stellen will, traegt ihn in
 * BESTIES_LAYOUT.titleTuning ein.
 *
 * ANLAESSE (07.08.2026): Ein Motiv, viele Produkte. Jeder Anlass ist nur ein
 * Satz Titel und Sprueche plus die Beschriftung der Namenszeile -- kein neuer
 * Code, keine neue Engine, kein neues Layout. Welcher Anlass gilt, setzt der
 * Section-Block ueber window.BESTIES_ANLASS; ohne Angabe greift 'besties'.
 *
 * Der slug wird nur noch als stabiler Schluessel gefuehrt. Die frueheren
 * Titel-Grafiken besties-title-<hell|dunkel>-<slug>.png sind tot: der Titel
 * wird als echter Text gerendert. */
(function (w) {
  'use strict';

  var ANLAESSE = {

    /* ---------------------------------------------------------------- */
    besties: {
      label: 'Beste Freundin, bester Freund',
      namesLabel: 'Eure Namen',
      namesPlaceholder: 'Marie & Lena',
      titles: [
        // Auswahl auf 6 gekuerzt (Ansage Dominik 09.08.) — gestrichene
        // Titel stehen in der Git-Historie.
        { slug: 'besties',          label: 'BESTIES' },
        { slug: 'best-friends',     label: 'BEST FRIENDS' },
        { slug: 'partner-in-crime', label: 'PARTNER IN CRIME' },
        { slug: 'seelenverwandt',   label: 'SEELENVERWANDT' },
        { slug: 'lieblingsmensch',  label: 'LIEBLINGSMENSCH' },
        { slug: 'seit-tag-eins',    label: 'SEIT TAG EINS' }
      ],
      quotes: [
        // Auswahl auf 6 gekuerzt (Ansage Dominik 09.08.).
        'Freunde sind die Familie, die man sich aussucht',
        'Seit Tag eins an deiner Seite',
        'Aus Zufall getroffen, aus Absicht geblieben',
        'Wir lachen über Dinge, die keiner versteht',
        'Zusammen sind wir unschlagbar',
        'Erst Freundschaft, dann Familie'
      ]
    },

    papa: {
      label: 'Papa',
      namesLabel: 'Namen der Kinder',
      namesPlaceholder: 'Emma & Luis',
      titles: [
        { slug: 'papa',             label: 'PAPA' },
        { slug: 'bester-papa',      label: 'BESTER PAPA' },
        { slug: 'lieblingspapa',    label: 'LIEBLINGSPAPA' },
        { slug: 'papabaer',         label: 'PAPABÄR' },
        { slug: 'mein-held',        label: 'MEIN HELD' },
        { slug: 'held-ohne-cape',   label: 'HELD OHNE CAPE' },
        { slug: 'super-papa',       label: 'SUPER PAPA' },
        { slug: 'dad',              label: 'DAD' },
        { slug: 'best-dad',         label: 'BEST DAD' },
        { slug: 'girl-dad',         label: 'GIRL DAD' },
        { slug: 'boy-dad',          label: 'BOY DAD' },
        { slug: 'papa-seit',        label: 'PAPA FÜR IMMER' },
        { slug: 'danke-papa',       label: 'DANKE PAPA' }
      ],
      quotes: [
        'Der erste Mann, der mein Herz gestohlen hat',
        'Mein Held braucht kein Cape',
        'Hinter jedem starken Kind steht ein Papa',
        'Groß geworden auf deinen Schultern',
        'Du hast mir das Radfahren beigebracht',
        'Deine Ruhe war immer mein Rückhalt',
        'Egal wie alt ich werde, du bleibst Papa',
        'Danke, dass du nie aufgegeben hast',
        'Wer braucht schon Helden, ich hab dich',
        'Von deiner Hand gehalten, seit Tag eins',
        'Papa sein ist keine Rolle, sondern Haltung',
        'Auf dich war immer Verlass',
        'Die besten Erinnerungen tragen deinen Namen'
      ]
    },

    /* ---------------------------------------------------------------- */
    mama: {
      label: 'Mama',
      namesLabel: 'Namen der Kinder',
      namesPlaceholder: 'Emma & Luis',
      titles: [
        { slug: 'mama',             label: 'MAMA' },
        { slug: 'beste-mama',       label: 'BESTE MAMA' },
        { slug: 'lieblingsmama',    label: 'LIEBLINGSMAMA' },
        { slug: 'mamabaer',         label: 'MAMABÄR' },
        { slug: 'meine-heldin',     label: 'MEINE HELDIN' },
        { slug: 'super-mama',       label: 'SUPER MAMA' },
        { slug: 'mom',              label: 'MOM' },
        { slug: 'best-mom',         label: 'BEST MOM' },
        { slug: 'mama-fuer-immer',  label: 'MAMA FÜR IMMER' },
        { slug: 'mamas-herz',       label: 'MAMAS HERZ' },
        { slug: 'danke-mama',       label: 'DANKE MAMA' },
        { slug: 'herzensmama',      label: 'HERZENSMAMA' }
      ],
      quotes: [
        'Die erste Liebe meines Lebens',
        'Zuhause ist da, wo du bist',
        'Deine Umarmung heilt bis heute alles',
        'Stark geworden, weil du stark warst',
        'Danke für jede durchwachte Nacht',
        'Egal wie alt ich werde, du bleibst Mama',
        'Meine Heldin trägt keinen Umhang',
        'Von dir gelernt, was Liebe bedeutet',
        'Dein Lachen kenne ich seit dem ersten Tag',
        'Du hast immer an mich geglaubt',
        'Mama sein ist keine Rolle, sondern Haltung',
        'Die besten Erinnerungen tragen deinen Namen'
      ]
    },

    /* ---------------------------------------------------------------- */
    schwester: {
      label: 'Schwester',
      namesLabel: 'Eure Namen',
      namesPlaceholder: 'Lena & Mia',
      titles: [
        { slug: 'schwesterherz',    label: 'SCHWESTERHERZ' },
        { slug: 'sisters',          label: 'SISTERS' },
        { slug: 'big-sis',          label: 'BIG SIS' },
        { slug: 'little-sis',       label: 'LITTLE SIS' },
        { slug: 'meine-schwester',  label: 'MEINE SCHWESTER' },
        { slug: 'schwestern',       label: 'SCHWESTERN' },
        { slug: 'sister-soul',      label: 'SISTER SOUL' },
        { slug: 'seelenverwandt-s', label: 'SEELENVERWANDT' },
        { slug: 'unzertrennlich-s', label: 'UNZERTRENNLICH' },
        { slug: 'fuer-immer-wir-s', label: 'FÜR IMMER WIR' }
      ],
      quotes: [
        'Erste Freundin, die ich nie ausgesucht habe',
        'Geschwister streiten, Schwestern bleiben',
        'Meine Kindheit hat deinen Namen',
        'Wir kennen die Geschichten hinter den Fotos',
        'Halbe Sätze reichen zwischen uns',
        'Dieselben Eltern, dieselben Macken',
        'Keine kennt mich länger als du',
        'Von der Kinderbank bis heute',
        'Wir teilen mehr als nur ein Zuhause',
        'Wer dich hat, braucht keine beste Freundin'
      ]
    },

    /* ---------------------------------------------------------------- */
    bruder: {
      label: 'Bruder',
      namesLabel: 'Eure Namen',
      namesPlaceholder: 'Tim & Jonas',
      titles: [
        { slug: 'brothers',         label: 'BROTHERS' },
        { slug: 'big-bro',          label: 'BIG BRO' },
        { slug: 'little-bro',       label: 'LITTLE BRO' },
        { slug: 'mein-bruder',      label: 'MEIN BRUDER' },
        { slug: 'brueder',          label: 'BRÜDER' },
        { slug: 'bruderherz',       label: 'BRUDERHERZ' },
        { slug: 'day-one-b',        label: 'DAY ONE' },
        { slug: 'ride-or-die-b',    label: 'RIDE OR DIE' },
        { slug: 'unzertrennlich-b', label: 'UNZERTRENNLICH' },
        { slug: 'fuer-immer-wir-b', label: 'FÜR IMMER WIR' }
      ],
      quotes: [
        'Erster Freund, den ich nie ausgesucht habe',
        'Geschwister streiten, Brüder bleiben',
        'Meine Kindheit hat deinen Namen',
        'Wir kennen die Geschichten hinter den Fotos',
        'Dieselben Eltern, dieselben Macken',
        'Keiner kennt mich länger als du',
        'Erst geprügelt, dann fürs Leben verbündet',
        'Von der Kinderbank bis heute',
        'Wir teilen mehr als nur ein Zuhause',
        'Ein Anruf genügt, und du bist da'
      ]
    },

    /* ---------------------------------------------------------------- */
    oma: {
      label: 'Oma',
      namesLabel: 'Namen der Enkel',
      namesPlaceholder: 'Emma & Luis',
      titles: [
        { slug: 'oma',              label: 'OMA' },
        { slug: 'beste-oma',        label: 'BESTE OMA' },
        { slug: 'lieblingsoma',     label: 'LIEBLINGSOMA' },
        { slug: 'omaherz',          label: 'OMAHERZ' },
        { slug: 'grandma',          label: 'GRANDMA' },
        { slug: 'best-grandma',     label: 'BEST GRANDMA' },
        { slug: 'omi',              label: 'OMI' },
        { slug: 'danke-oma',        label: 'DANKE OMA' },
        { slug: 'oma-fuer-immer',   label: 'OMA FÜR IMMER' }
      ],
      quotes: [
        'Bei dir schmeckt alles nach Kindheit',
        'Deine Tür stand immer offen',
        'Zuhause riecht nach deiner Küche',
        'Du hast Zeit, wenn alle keine haben',
        'Von dir gelernt, was Geduld bedeutet',
        'Die schönsten Sommer waren bei dir',
        'Deine Geschichten kenne ich auswendig',
        'Bei Oma gelten andere Regeln',
        'Danke für jede zweite Portion',
        'Die besten Erinnerungen tragen deinen Namen'
      ]
    },

    /* ---------------------------------------------------------------- */
    opa: {
      label: 'Opa',
      namesLabel: 'Namen der Enkel',
      namesPlaceholder: 'Emma & Luis',
      titles: [
        { slug: 'opa',              label: 'OPA' },
        { slug: 'bester-opa',       label: 'BESTER OPA' },
        { slug: 'lieblingsopa',     label: 'LIEBLINGSOPA' },
        { slug: 'opaherz',          label: 'OPAHERZ' },
        { slug: 'grandpa',          label: 'GRANDPA' },
        { slug: 'best-grandpa',     label: 'BEST GRANDPA' },
        { slug: 'opi',              label: 'OPI' },
        { slug: 'danke-opa',        label: 'DANKE OPA' },
        { slug: 'opa-fuer-immer',   label: 'OPA FÜR IMMER' }
      ],
      quotes: [
        'Bei dir war immer Werkstatt und Abenteuer',
        'Deine Tür stand immer offen',
        'Von dir gelernt, was Ruhe bedeutet',
        'Die schönsten Sommer waren bei dir',
        'Deine Geschichten kenne ich auswendig',
        'Bei Opa gelten andere Regeln',
        'Du hast mir das Angeln beigebracht',
        'Ein Handschlag von dir zählt mehr als Worte',
        'Danke für jede geschenkte Stunde',
        'Die besten Erinnerungen tragen deinen Namen'
      ]
    },

    /* ---------------------------------------------------------------- */
    partner: {
      label: 'Partnerin, Partner',
      namesLabel: 'Eure Namen',
      namesPlaceholder: 'Anna & Ben',
      titles: [
        { slug: 'wir-zwei-p',       label: 'WIR ZWEI' },
        { slug: 'fuer-immer-p',     label: 'FÜR IMMER' },
        { slug: 'my-person',        label: 'MY PERSON' },
        { slug: 'lieblingsmensch-p',label: 'LIEBLINGSMENSCH' },
        { slug: 'seelenverwandt-p', label: 'SEELENVERWANDT' },
        { slug: 'you-and-me',       label: 'YOU & ME' },
        { slug: 'us',               label: 'US' },
        { slug: 'zuhause',          label: 'ZUHAUSE' },
        { slug: 'mein-mensch',      label: 'MEIN MENSCH' },
        { slug: 'seit-tag-eins-p',  label: 'SEIT TAG EINS' }
      ],
      quotes: [
        'Zuhause ist kein Ort, sondern du',
        'Aus Zufall getroffen, aus Absicht geblieben',
        'Mit dir wird jeder normale Tag besser',
        'Halbe Sätze reichen zwischen uns',
        'Auf noch hundert Jahre',
        'Gemeinsam durch jeden Sturm',
        'Du bist meine Lieblingsentscheidung',
        'Wir lachen über Dinge, die keiner versteht',
        'Neben dir schlägt alles ruhiger',
        'Von Anfang an und immer noch'
      ]
    },

    /* ---------------------------------------------------------------- */
    familie: {
      label: 'Familie',
      namesLabel: 'Eure Namen',
      namesPlaceholder: 'Familie Berger',
      titles: [
        { slug: 'familie',          label: 'FAMILIE' },
        { slug: 'family',           label: 'FAMILY' },
        { slug: 'unsere-familie',   label: 'UNSERE FAMILIE' },
        { slug: 'zuhause-f',        label: 'ZUHAUSE' },
        { slug: 'wir',              label: 'WIR' },
        { slug: 'home',             label: 'HOME' },
        { slug: 'fuer-immer-wir-f', label: 'FÜR IMMER WIR' },
        { slug: 'zusammen',         label: 'ZUSAMMEN' },
        { slug: 'meine-leute',      label: 'MEINE LEUTE' }
      ],
      quotes: [
        'Zuhause ist da, wo wir alle sind',
        'Laut, chaotisch und genau richtig',
        'Gemeinsam durch jeden Sturm',
        'Kein Ort ist wie unser Küchentisch',
        'Wir streiten, wir bleiben',
        'Die besten Geschichten passieren hier',
        'Aus vielen Menschen ein Zuhause',
        'Immer da, auch ohne Worte',
        'Erst Familie, dann alles andere',
        'Von Anfang an und immer noch'
      ]
    }
  };

  /* Welcher Anlass gilt, entscheidet der Block auf der PDP. Faellt der Wert
     weg oder ist er unbekannt, greift 'besties' -- ein Editor ohne Auswahl
     waere schlimmer als der falsche Satz Vorschlaege. */
  var gewaehlt = ANLAESSE[w.BESTIES_ANLASS] ? w.BESTIES_ANLASS : 'besties';
  var A = ANLAESSE[gewaehlt];

  w.BESTIES_PRESETS = {
    anlass: gewaehlt,
    anlassLabel: A.label,
    titles: A.titles,
    quotes: A.quotes,
    namesLabel: A.namesLabel,
    namesPlaceholder: A.namesPlaceholder,
    maxQuoteChars: 60,
    maxNamesChars: 35,
    /* Vollstaendige Tabelle, damit Werkzeuge und spaetere Produkte sie lesen
       koennen, ohne die Datei zu parsen. */
    anlaesse: ANLAESSE
  };
})(window);
